/**
 * This is a store that hold left panel state
 * It could be one of the ActivePanelId
 *
 * Using useStorage from @vueuse/core allow persistance storage accross tabs/sessions
 *
 * We can import and set activePanel anywhere in our project
 * @see /src/components/partials/toolbars/Toolbar.vue
 * @see /src/components/partials/panels/ActivityPanel.vue
 */

import { useStorage } from '@vueuse/core'
import {ref} from "vue";

export type ActivePanelId =
  | 'none'
  | 'search'
  | 'languages'
  | 'activity'
  | 'task'
  | 'tag'
  | 'searchContent'
  | 'editFile'
  | 'uploadFile'
  | 'editLink'
  | 'searchUser'
  | 'searchTags'
  | 'searchCoupon'
  | 'searchProduct'
  | 'searchArticle'
  | 'searchOmenReport'
  | 'searchVideo'
  | 'searchLink'
  | 'searchRoadshow'
  | 'searchReport'
  | 'roadshowGroup'
  | 'searchGroup'
  | 'userGroup'
  | 'navigatorCategory'
  | 'navigatorCategoryEdit'
  | 'navigatorSite'
  | 'navigatorSiteEdit'
  | 'calendarList'
  | 'calendarTemplate'
  | 'rssEdit'
  | 'sourceGroup'
  | 'contents'
  | 'calendarTopicPanel'
  | 'dataGroup'
  | 'excelPreview'
  | 'reportCategory'
  | 'omenCategory'
  | 'searchPost'
  | 'searchTranscript'

export const activePanel = useStorage<ActivePanelId>('active-panel', 'none')

export const activeInnerPanel = ref<string>()
